// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8S5yB","footer":"styles_footer__1yn0V"};